export class UserAndLeadWiseLeads
{
    userName:string
    status:string
    count:number
}